import { render, staticRenderFns } from "./Burger.vue?vue&type=template&id=6426fa44&scoped=true"
import script from "./Burger.vue?vue&type=script&lang=js"
export * from "./Burger.vue?vue&type=script&lang=js"
import style0 from "./Burger.vue?vue&type=style&index=0&id=6426fa44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6426fa44",
  null
  
)

export default component.exports